import React from 'react'
import { Button, Form, Modal, TextArea, Message } from 'semantic-ui-react'
import { submitFeedback } from 'services/feedback'
import { isAuthenticated } from 'services/self'
import { getCognitoUrl } from '../components/NavBar'

const initialState = {
  message: '',
  formOpen: false,
  feedbackSubmitted: false
}

class Feedback extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = initialState

    this.handleOpenModal = () => {
      this.setState({
        formOpen: true
      })
    }

    this.handleCloseModal = () => {
      this.setState(initialState)
    }

    this.handleSubmit = () => {
      const { message } = this.state
      submitFeedback(message).then(() => {
        this.setState({
          feedbackSubmitted: true
        })
      })
    }
  }

  render () {
    const {
      message,
      formOpen,
      feedbackSubmitted
    } = this.state

    return (
      <Modal
        closeIcon
        centered={false}
        size='tiny'
        open={formOpen}
        onClose={this.handleCloseModal}
        trigger={
          <div style={{
            display: 'block',
            position: 'fixed',
            top: '70%',
            right: '-62px', // Adjusted for rotation
            transform: 'rotate(90deg)'
          }}
          >
            <Button
              style={{
                borderTopLeftRadius: '0',
                borderTopRightRadius: '0'
              }} onClick={this.handleOpenModal}
              className='ui primary button'
            ><i className='envelope outline icon' />Got an opinion?
            </Button>
          </div>
        }
      >
        <Modal.Header>Let us know!</Modal.Header>
        <Modal.Content>
          {!feedbackSubmitted &&
            <Form>
              {isAuthenticated() ? <>
                <Form.Field>
                  <TextArea value={message} placeholder="Provide your thoughts" onChange={(e) => this.setState({ message: e.target.value })} />
                </Form.Field>

                <Button type='submit' positive onClick={this.handleSubmit}>Submit</Button>

                <Button negative onClick={this.handleCloseModal} style={{
                  float: 'right'
                }}>Cancel</Button>
              </> : <p>
                Please <a href={getCognitoUrl('login')}>Sign In</a> to submit feedback.
              </p>}
            </Form>}

          {feedbackSubmitted &&
            <Message positive>
              <p>Thanks for your feedback</p>
            </Message>}
        </Modal.Content>
      </Modal>
    )
  }
}

export default Feedback
